"use strict";

exports.__esModule = true;
exports.EditableSurfaceItemWrapper = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reResizable = require("re-resizable");
var _styledComponents = require("styled-components");
var _reactDnd = require("react-dnd");
var _ConfigurableLayout = require("../../ConfigurableLayout");
var _getDecoratedNode = require("../../../Utils/getDecoratedNode");
var _excluded = ["path", "element", "elementEditor", "children", "theme", "isDragging", "connectDragPreview", "connectDragSource", "connectDropTarget"];
var _dec, _dec2, _dec3, _class, _EditableSurfaceItemWrapper;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var elementSource = {
  beginDrag: function beginDrag(props) {
    var element = props.element,
      path = props.path,
      elementEditor = props.elementEditor;
    elementEditor.beginDrag(path);
    return {
      element: element,
      path: path
    };
  },
  endDrag: function endDrag(props) {
    var elementEditor = props.elementEditor;
    elementEditor.endDrag();
  }
};
var widgetTarget = {
  drop: function drop(props, monitor, component) {
    var elementEditor = props.elementEditor;
    var hasDroppedOnChild = monitor.didDrop();
    if (hasDroppedOnChild || !monitor.isOver({
      shallow: true
    })) {
      return;
    }
    var itemType = monitor.getItemType();
    if (itemType === "element") {
      var delta = monitor.getDifferenceFromInitialOffset();
      var _monitor$getItem = monitor.getItem(),
        element = _monitor$getItem.element,
        path = _monitor$getItem.path;
      var x = Math.round((element.props.x || 0) + delta.x);
      var y = Math.round((element.props.y || 0) + delta.y);
      var _element$props = element.props,
        width = _element$props.width,
        height = _element$props.height;
      elementEditor.moveElementAt(path, props.path, {
        x: x,
        y: y,
        width: width,
        height: height
      });
    } else if (itemType === "widget") {
      var componentNode = (0, _getDecoratedNode.getDecoratedNode)(component);
      var domNode = (0, _getDecoratedNode.resolveRelativeDropNode)(componentNode, props.path.length);
      if (domNode == null) {
        return;
      }
      if (domNode instanceof Element) {
        var rect = domNode.getBoundingClientRect();
        var _delta = monitor.getSourceClientOffset();
        var _monitor$getItem2 = monitor.getItem(),
          widget = _monitor$getItem2.widget;
        var _x = Math.round(_delta.x - rect.left);
        var _y = Math.round(_delta.y - rect.top);
        var _element = widget.createElement({
          x: _x,
          y: _y
        });
        elementEditor.appendElementAt(props.path, _element);
      }
    }
  }
};
var getPosition = function getPosition(_ref) {
  var x = _ref.x,
    y = _ref.y,
    width = _ref.width,
    height = _ref.height,
    element = _ref.element;
  return {
    x: element.props.x || x || 0,
    y: element.props.y || y || 0,
    width: width || element.props.width || 128,
    height: height || element.props.height || 64
  };
};

/**
 * Wraps an element to make it clickable, draggable, resizable, selectable.
 */
var EditableSurfaceItemWrapper = exports.EditableSurfaceItemWrapper = (_dec = _ConfigurableLayout.ElementEditorContext.withContext, _dec2 = (0, _reactDnd.DropTarget)(["widget", "element"], widgetTarget, function (connect) {
  return {
    connectDropTarget: connect.dropTarget()
  };
}), _dec3 = (0, _reactDnd.DragSource)("element", elementSource, function (connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    isDragging: monitor.isDragging()
  };
}), (0, _styledComponents.withTheme)(_class = _dec(_class = _dec2(_class = _dec3(_class = (_EditableSurfaceItemWrapper = /*#__PURE__*/function (_Component) {
  function EditableSurfaceItemWrapper() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      original: getPosition(_this.props),
      current: getPosition(_this.props)
    };
    _this.node = null;
    _this.setNode = function (el) {
      _this.node = el;
    };
    _this.getNode = function () {
      return _this.node;
    };
    _this.handleResizeStart = function (e) {
      e.stopPropagation();
      e.preventDefault();
      var _this$props = _this.props,
        path = _this$props.path,
        elementEditor = _this$props.elementEditor;
      if (!elementEditor.isElementSelectedAt(path)) {
        elementEditor.selectElementAt(path);
      }
      var position = getPosition(_this.props);
      _this.setState({
        original: position,
        current: position
      });
    };
    _this.handleResize = function (e, direction, ref, delta) {
      var _this$state$original = _this.state.original,
        width = _this$state$original.width,
        height = _this$state$original.height;
      var _this$state$original2 = _this.state.original,
        x = _this$state$original2.x,
        y = _this$state$original2.y;
      if (direction === "top" || direction === "topRight" || direction === "topLeft") {
        y -= delta.height;
      }
      if (direction === "left" || direction === "topLeft" || direction === "bottomLeft") {
        x -= delta.width;
      }
      _this.setState({
        current: {
          x: x,
          y: y,
          width: width + delta.width,
          height: height + delta.height
        }
      });
    };
    _this.handleResizeStop = function () {
      var _this$props2 = _this.props,
        path = _this$props2.path,
        elementEditor = _this$props2.elementEditor;
      elementEditor.setProps(path, _this.state.current);
    };
    _this.handleClick = function (e) {
      e.preventDefault();
      e.stopPropagation();
      var _this$props3 = _this.props,
        path = _this$props3.path,
        elementEditor = _this$props3.elementEditor;
      elementEditor.selectElementAt(path);
    };
    return _this;
  }
  _inheritsLoose(EditableSurfaceItemWrapper, _Component);
  EditableSurfaceItemWrapper.getDerivedStateFromProps = function getDerivedStateFromProps(props, prevState) {
    var position = getPosition(props);
    if (prevState.original.x === position.x && prevState.original.y === position.y && prevState.original.width === position.width && prevState.original.height === position.height) {
      return null;
    }
    return {
      original: position,
      current: position
    };
  };
  var _proto = EditableSurfaceItemWrapper.prototype;
  _proto.render = function render() {
    var _this$props4 = this.props,
      path = _this$props4.path,
      element = _this$props4.element,
      elementEditor = _this$props4.elementEditor,
      children = _this$props4.children,
      theme = _this$props4.theme,
      isDragging = _this$props4.isDragging,
      connectDragPreview = _this$props4.connectDragPreview,
      connectDragSource = _this$props4.connectDragSource,
      connectDropTarget = _this$props4.connectDropTarget,
      extra = _objectWithoutPropertiesLoose(_this$props4, _excluded);
    var isSelected = elementEditor.isElementSelectedAt(path);
    var isResizable = path.length > 0 && elementEditor.canResizeElementAt(path);
    var isDraggable = path.length > 0 && element.type !== "Surface";
    var _this$state$current = this.state.current,
      x = _this$state$current.x,
      y = _this$state$current.y,
      width = _this$state$current.width,
      height = _this$state$current.height;
    var outline = isSelected ? "solid 1px " + theme.selectedBorderColor : "dashed 1px " + theme.borderColor;
    var zIndex = isSelected ? 999 : "auto";
    var style = {
      position: "absolute",
      top: y,
      left: x,
      width: width,
      height: height,
      outline: outline,
      zIndex: zIndex
    };

    // $FlowFixMe
    extra.onClick = this.handleClick;
    if (element.children.length === 0) {
      // $FlowFixMe
      extra.onClickCapture = this.handleClick;
    }
    var body = _react.Children.map(children, function (child) {
      return /*#__PURE__*/(0, _react.cloneElement)(child, Object.assign({}, extra, {
        x: 0,
        y: 0,
        width: width,
        height: height
      }));
    });
    if (isResizable) {
      body = /*#__PURE__*/_react["default"].createElement("div", null, body);
    } else {
      body = /*#__PURE__*/_react["default"].createElement("div", {
        style: style
      }, body);
    }
    if (isDraggable) {
      body = connectDragSource(body);
    }
    body = connectDropTarget(body);
    if (isResizable) {
      body = /*#__PURE__*/_react["default"].createElement(_reResizable.Resizable, {
        size: {
          width: width,
          height: height
        },
        style: style,
        minWidth: 16,
        minHeight: 16,
        grid: [16, 16],
        onResizeStart: this.handleResizeStart,
        onResize: this.handleResize,
        onResizeStop: this.handleResizeStop
      }, body);
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      ref: this.setNode,
      style: {
        display: "contents"
      }
    }, body);
  };
  return EditableSurfaceItemWrapper;
}(_react.Component), _EditableSurfaceItemWrapper.defaultProps = {
  elementEditor: undefined,
  theme: undefined,
  connectDragPreview: undefined,
  connectDragSource: undefined,
  connectDropTarget: undefined,
  isDragging: undefined
}, _EditableSurfaceItemWrapper)) || _class) || _class) || _class) || _class);